export default __webpack_public_path__ + "static/img/location.d623b97.svg";